import { render, staticRenderFns } from "./JobCategorySetting.vue?vue&type=template&id=41663e5c"
import script from "./JobCategorySetting.vue?vue&type=script&lang=js"
export * from "./JobCategorySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports